<template>
  <v-expansion-panel class="elevation-1" outlined style=" margin:3px 0px; background-color: #F5F5F5;">
    <v-expansion-panel-content v-for="(item, i) in 1" :key="i">
      <template v-slot:header>
        <div>
          Comentarios Equipo Local
          <v-chip class="ma-2" color="teal" text-color="white">{{totalComments}}</v-chip>
        </div>
      </template>
      <v-card>
        <v-card-text>
        <div v-for="item in listComments" :key="item.id" class="text-xs chat-container ">
        <template v-if="item.bubbleClass === 'chat-bubble'">
        <div class="chat-bubble-wrapper">
         <v-chip :style="{backgroundColor: item.color}"
            >{{item.usernameAuthor}} </v-chip>
            <div class="chat-bubble">
              {{item.createdAt}}  -    - <b> {{item.comment}}</b>
            </div>
            </div>
        </template >
        <template v-else>
         <div class="chat-bubble-right-wrapper">
        <div class="chat-bubble-right">
              {{item.createdAt}}  -    - <b> {{item.comment}}</b>
            </div>
         <v-chip :style="{backgroundColor: item.color}"
            >{{item.usernameAuthor}} </v-chip>
 </div>
        </template>
        </div>
        </v-card-text >
          <div class="d-flex flex-row align-center mx-4">
            <v-textarea
            v-model="msg"
            placeholder="Escribe un Comentario"
            max-height="200"
            maxlength="300"
            :counter="300"
            class="custom-textarea"
            @keypress.enter="send"
          ></v-textarea>
            <v-btn dark class="ml-4" color="primary"
                :style="{ opacity: msg ? 1 : 0.5, 'pointer-events': msg ? 'auto' : 'none' }"
                @click="send"
                ><v-icon>mdi-send</v-icon></v-btn
            >
          </div>
      </v-card>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
export default {
  props: {
    informe: Object
  },
  data () {
    return {
      listComments: null,
      totalComments: 0,
      msg: '',
      authorColors: {},
      colors: ['LightSkyBlue', 'PaleGreen', 'PapayaWhip', 'MistyRose'],
      indexColor: 0,
      prevClassBuble: 'chat-bubble'

    }
  },
  methods: {
    fetchCommentsByIdReport () {
      this.loading = true
      this.axios
        .get(`report-response-local-discharge`, {
          params: {
            informe: this.informe.pk
          }
        })
        .then(response => {
          this.listComments = response.data
          this.totalComments = response.data.length
          // agregar color aleatorio a cada autor de comentario
          this.listComments.forEach(comment => {
            if (!this.authorColors[comment.usernameAuthor]) {
              this.authorColors[comment.usernameAuthor] = this.colors[this.indexColor]
              if (this.indexColor === (this.colors.length - 1)) {
                this.indexColor = 0
              } else {
                this.indexColor++
              }
            }
            comment.color = this.authorColors[comment.usernameAuthor]
            comment.bubbleClass = (comment.isUserSaf === true) ? 'chat-bubble-right' : 'chat-bubble'
          })
          this.loading = false
        })
        .catch(error => {
          this.$store.commit('setErrorMsg', error)
        })
    },
    send (event) {
      this.loading = true
      let payload = {
        report_response: this.informe.pk,
        author: this.$store.state.authUser,
        comment: this.msg
      }
      this.axios
        .post(`report-response-local-discharge`, payload)
        .then(response => {
          let color = this.authorColors[this.$store.state.authUser]
          if (!color) {
            color = this.colors[this.indexColor]
            this.authorColors[this.$store.state.authUser] = color
            if (this.indexColor === (this.colors.length - 1)) {
              this.indexColor = 0
            } else {
              this.indexColor++
            }
          }
          response.data.color = color
          response.data.bubbleClass = (response.data.isUserSaf === true) ? 'chat-bubble-right' : 'chat-bubble'

          this.listComments.push(response.data)
          this.loading = false
          this.msg = ''
          this.totalComments++
        })
        .catch(error => {
          this.$store.commit('setErrorMsg', error)
        })
    },
    isSameAuthor (index, item) {
      return item.usernameAuthor === this.listComments[index - 1].usernameAuthor
    }
  },
  computed: {
  },
  components: {},
  created () {
    this.fetchCommentsByIdReport()
  }
}
</script>
<style>
.custom-textarea {
    border: 1px solid #d9d9d9;
    border-radius: 4px;
    padding: 10px;
    font-size: 14px;
    line-height: 1.5;
    resize: vertical;
    min-height: 80px;
    margin-bottom: 15px;
    }

  .chat-bubble {
  display: inline-block;
  position: relative;
  margin: 10px;
  padding: 10px;
  min-width:300px;
  border-radius: 20px;
  background-color: #E0E0E0;
  max-width: 85%;
  word-break: break-all;
  border: 1px solid darken(#E0E0E0, 10%);
}

.chat-bubble::after {
  content: "";
  position: absolute;
  top: 50%;
  left: -10px;
  border-style: solid;
  border-width: 10px 10px 10px 0;
  border-color: transparent #E0E0E0 transparent transparent;
  transform: translateY(-50%);
}

.chat-bubble-right {
  display: inline-block;
  position: relative;
  margin: 10px;
  padding: 10px;
  min-width:300px;
  border-radius: 20px;
  background-color: #E0E0E0;
  max-width: 85%;
  word-break: break-all;
  border: 1px solid darken(#E0E0E0, 10%);
}

.chat-bubble-right::after {
  content: "";
  position: absolute;
  top: 50%;
  right: -10px;
  border-style: solid;
  border-width: 10px 0 10px 10px;
  border-color:   transparent  transparent transparent #E0E0E0 ;
  transform: translateY(-50%);
}

.chat-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.chat-bubble-right-wrapper {
  align-self: flex-end;
}
.chat-bubble-wrapper {

  align-self: flex-start;
}

</style>
